export default __webpack_public_path__ + "static/media/twist-transparent-logo.5fe3d6b9.png";